export default __webpack_public_path__ + "static/media/425onefloorplan.92c76f00.svg";